<script lang="ts">
    import type { Deal } from '@shared/types/types';

    interface Props {
        deal: Deal;
        variationId: string;
        rule?: string;
    }

    let { deal, variationId, rule }: Props = $props();

    const url = $derived(
        rule
            ? `/benefit-sheet/sheet/listProductCampaignFlag/${deal.dealId}?variationId=${variationId}&contextDreson=${rule}`
            : undefined,
    );
</script>

{#if deal.image && url}
    <div data-oc-sheet-v1-create data-oc-sheet-v1-create.base64-url={btoa(url)}>
        <img class="reptile-tile__deal-badge-image" src={deal.image.src} alt={deal.image.alt} />
    </div>
{/if}

<style lang="scss">
    @use '@otto-ec/otto-components-utils/scss/mixins' as mixins;
    .reptile-tile__deal-badge-image {
        position: absolute;
        top: 6px;
        left: 6px;
        z-index: 1;
        height: 40px;
        cursor: pointer;

        /*                                                                                */
        /*                                                                           */
        /*                                                                                  */
        pointer-events: auto;

        @include mixins.breakpoint-from-m($to: 'l') {
            height: 50px;
        }

        @include mixins.breakpoint-from-l($to: 'xl') {
            height: 40px;
        }

        @include mixins.breakpoint-from-xl() {
            height: 50px;
        }
    }
</style>
